import { SetupCardComponent } from "./setup-card/setup-card.component";
import { SetupDetailComponent } from "./setup-detail/setup-detail.component";

export {
  SetupCardComponent,
  SetupDetailComponent,
};

export const setupComponents = [
  SetupCardComponent,
  SetupDetailComponent,
]